const computeWeeklyInterval = (data, rruleObj) => {
  if (rruleObj.freq !== 2) {
    return data.repeat.weekly.interval;
  }

  return rruleObj.interval;
};

export default computeWeeklyInterval;



// WEBPACK FOOTER //
// ./src/lib/utils/computeRRule/fromString/computeWeeklyInterval.js